import React, { useEffect, useState } from "react";
import "./Team.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faLinkedinIn, faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";

function TeamRow({ title, members }) {
  return (
    <div className="mb-5">
      {title && <h3 className="text-center text-warning mb-4">{title}</h3>}
      <div className="row justify-content-center g-4">
        {members.map((member, index) => (
          <div key={index} className="col-md-6 d-flex">
            <div className="team-card d-flex flex-column flex-md-row align-items-center bg-dark p-4 rounded shadow w-100">
              <img
                src={`/image/${member.image}`}
                alt={member.name}
                className="team-photo mb-3 mb-md-0 me-md-4 rounded-circle"
                style={{ width: "200px", height: "200px", objectFit: "cover" }}
              />
              <div>
                <h5 className="fw-normal mb-1" style={{ color: '#FFD166' }}>{member.role}</h5>
                <h4 className="fw-bold mb-1" style={{ color: '#FFFFFF' }}>{member.name}</h4>
                {member.career && (
                  <p className="mb-1 small">{member.career}</p>
                )}
                {member.education && (
                  <p className="mb-3 small fst-italic">{member.education}</p>
                )}
                {member.description && (
                  <p className="mb-3 small">{member.description}</p>
                )}
                {member.funFact && (
                  <p className="mb-3 small"><strong>Fun Fact: </strong>{member.funFact}</p>
                )}
                {member.quote && (
                  <p className="mb-1 small fst-italic text-warning">{member.quote}</p>
                )}
                <div className="d-flex gap-3 mt-2">
                  {member.email && (
                    <a href={`mailto:${member.email}`} style={{ color: "#fff" }}>
                      <FontAwesomeIcon icon={faEnvelope} />
                    </a>
                  )}
                  {member.linkedin && (
                    <a href={member.linkedin} target="_blank" rel="noopener noreferrer" style={{ color: "#fff" }}>
                      <FontAwesomeIcon icon={faLinkedinIn} />
                    </a>
                  )}
                  {member.facebook && (
                    <a href={member.facebook} target="_blank" rel="noopener noreferrer" style={{ color: "#fff" }}>
                      <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                  )}
                  {member.instagram && (
                    <a href={member.instagram} target="_blank" rel="noopener noreferrer" style={{ color: "#fff" }}>
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Team() {
  const [teamData, setTeamData] = useState(null);

  useEffect(() => {
    fetch("/data/team.json")
      .then(res => res.json())
      .then(data => setTeamData(data));
  }, []);

  if (!teamData) return <div className="text-center text-white">Loading team...</div>;

  return (
    <section id="team" className="team-section text-white bg-black py-5">
      <div className="container">
        <h2 className="mb-4 text-center">Meet The Team</h2>
        <TeamRow title="Leads & Curators" members={teamData.leadCurators} />
        <TeamRow title="Creative & Tech" members={teamData.creativeTeam} />
        <TeamRow title="Production & Events" members={teamData.productionTeam} />
      </div>
    </section>
  );
}
